import React from 'react';
import Pie from '@splunk/dashboard-visualizations/Pie';

export default () => (
    <Pie
        options={{
            hasDonutHole: true,
            'legend.labelStyle.overflowMode': 'ellipsisEnd',
        }}
        encoding={{
            value: 'primary.count',
            label: 'primary.component',
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'component' }, { name: 'count' }],
                    columns: [
                        [
                            'January is one of the darkest month of the year',
                            'February',
                            'March',
                            'April',
                            'May',
                            'June',
                            'July',
                            'August is one of the hottest month of the year',
                            'September',
                            'October',
                            'November',
                            'December is the one of the coldest month of the year',
                        ],
                        ['3', '1', '1', '2', '10', '10', '5', '5', '5', '5', '5', '50'],
                    ],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
